import { apiSliceV2Generated as api } from "../../../../apiSlice";
export const addTagTypes = ["AlarmConfiguration"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getAlarmConfiguration: build.query<
        GetAlarmConfigurationApiResponse,
        GetAlarmConfigurationApiArg
      >({
        query: (queryArg) => ({ url: `/v2/AlarmConfiguration/${queryArg.id}` }),
        providesTags: ["AlarmConfiguration"],
      }),
      putAlarmConfiguration: build.mutation<
        PutAlarmConfigurationApiResponse,
        PutAlarmConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/AlarmConfiguration/${queryArg.id}`,
          method: "PUT",
          body: queryArg.putAlarmConfigurationDto,
        }),
        invalidatesTags: ["AlarmConfiguration"],
      }),
      deleteAlarmConfiguration: build.mutation<
        DeleteAlarmConfigurationApiResponse,
        DeleteAlarmConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/AlarmConfiguration/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["AlarmConfiguration"],
      }),
      getAlarmConfigurations: build.query<
        GetAlarmConfigurationsApiResponse,
        GetAlarmConfigurationsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/AlarmConfiguration`,
          params: {
            AccountIds: queryArg.accountIds,
            OrderBy: queryArg.orderBy,
            OrderDirection: queryArg.orderDirection,
            Top: queryArg.top,
            Skip: queryArg.skip,
          },
        }),
        providesTags: ["AlarmConfiguration"],
      }),
      postAlarmConfiguration: build.mutation<
        PostAlarmConfigurationApiResponse,
        PostAlarmConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/AlarmConfiguration`,
          method: "POST",
          body: queryArg.postAlarmConfigurationDto,
        }),
        invalidatesTags: ["AlarmConfiguration"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcV2OpenApi };
export type GetAlarmConfigurationApiResponse =
  /** status 200 OK */ GetAlarmConfigurationDto;
export type GetAlarmConfigurationApiArg = {
  id: number;
};
export type PutAlarmConfigurationApiResponse = unknown;
export type PutAlarmConfigurationApiArg = {
  id: number;
  putAlarmConfigurationDto: PutAlarmConfigurationDto;
};
export type DeleteAlarmConfigurationApiResponse = unknown;
export type DeleteAlarmConfigurationApiArg = {
  id: number;
};
export type GetAlarmConfigurationsApiResponse =
  /** status 200 OK */ GetAlarmConfigurationDto[];
export type GetAlarmConfigurationsApiArg = {
  accountIds?: number[];
  orderBy?: string;
  orderDirection?: "desc" | "asc";
  top?: number;
  skip?: number;
};
export type PostAlarmConfigurationApiResponse =
  /** status 201 Created */ GetAlarmConfigurationDto;
export type PostAlarmConfigurationApiArg = {
  postAlarmConfigurationDto: PostAlarmConfigurationDto;
};
export type AlarmTypes =
  | "TimeBetweenConsumption"
  | "ConsumptionLevel"
  | "SeepLeakage"
  | "SensorDown"
  | "ActivityTimer"
  | "ExternalSensorDown"
  | "ThresholdLimit"
  | "FastSensorDown"
  | "BurstLeakage"
  | "TemperatureDeviation"
  | "HeatingSystem"
  | "VentilationSystem"
  | "CoolingSystem"
  | "BillingMeter"
  | "PowerDisaggregation"
  | "LowBattery"
  | "ElectricitySystem"
  | "PEOOperations"
  | "EnergyXOperations"
  | "PortfolioOperations"
  | "WaterSystem"
  | "UsageOverTime"
  | "QualityOfServiceDataStream";
export type Severity =
  | "Information"
  | "Trivial"
  | "Minor"
  | "Medium"
  | "Major"
  | "Critical";
export type IntAssociation = {
  id?: number;
  name?: string | null;
};
export type GuidAssociation = {
  id?: string;
  name?: string | null;
};
export type DataStreamAssociation = {
  unitId?: number;
  unitTypeInputId?: number | null;
  dataType?: string | null;
};
export type AssociationsDto = {
  units?: IntAssociation[] | null;
  buildings?: IntAssociation[] | null;
  jobSubscriptions?: IntAssociation[] | null;
  sensors?: IntAssociation[] | null;
  gateways?: IntAssociation[] | null;
  energyGroups?: IntAssociation[] | null;
  energyInitiatives?: IntAssociation[] | null;
  energyTreeNodes?: GuidAssociation[] | null;
  dataStreams?: DataStreamAssociation[] | null;
};
export type GetAlarmConfigurationDto = {
  alarmConfigurationId?: number;
  accountId?: number;
  title?: string | null;
  message?: string | null;
  configurations?: object | null;
  alarmType?: AlarmTypes;
  alarmSubtype?: string | null;
  severity?: Severity;
  created?: string;
  associations?: AssociationsDto;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type PutAlarmConfigurationDto = {
  title?: string | null;
  message?: string | null;
  configurations?: object | null;
  alarmType?: AlarmTypes;
  alarmSubtype?: string | null;
  severity?: Severity;
  associations?: AssociationsDto;
};
export type PostAlarmConfigurationDto = {
  accountId?: number;
  title?: string | null;
  message?: string | null;
  configurations?: object | null;
  alarmType?: AlarmTypes;
  alarmSubtype?: string | null;
  severity?: Severity;
  associations?: AssociationsDto;
};
export const {
  useGetAlarmConfigurationQuery,
  usePutAlarmConfigurationMutation,
  useDeleteAlarmConfigurationMutation,
  useGetAlarmConfigurationsQuery,
  usePostAlarmConfigurationMutation,
} = injectedRtkApi;
